import { render, staticRenderFns } from "./KeepInTouch.vue?vue&type=template&id=2f942b34&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBusinessInfo: require('/opt/buildhome/repo/components/base/BusinessInfo.vue').default,BaseContactForm: require('/opt/buildhome/repo/components/base/ContactForm.vue').default,BaseSection: require('/opt/buildhome/repo/components/base/Section.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/@nuxtjs/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
